<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <app-shared-header-div [screentitle] ="screentitle" [headerDivName]="headerDivName"
       [actionmode]="actionmode" (submitDataOne)="submitData1($event)" (search_Form)="searchForm($event)">
    </app-shared-header-div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 2% 2% 2%">
                  vfhjdskl
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>Fare Product Search</h1>
    <div class="bothbuttdiv">

    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div>

                    <div>
                      <div class="col-lg-3">
                        <label>Origin</label>
                        <input [(ngModel)]="screen_details.origin" type="text" class="form-control m-input"
                          placeholder="Enter City Code" />
                      </div>

                      <div class="col-lg-3">
                        <label>Destination</label>
                        <input [(ngModel)]="screen_details.destination" type="text" class="form-control m-input"
                          placeholder="Enter City Code" />
                      </div>

                      <div class="col-lg-3">
                        <label class="">Tripvalue</label>

                        <select class="form-control" [(ngModel)]="screen_details.tripvalue">
                          <option disabled value="0">Select Cabin Class</option>
                          <option value="A">A</option>
                          <option value="B">B</option>
                          <option value="C">C</option>
                          <option value="D">D</option>
                          <option value="E">E</option>
                        </select>
                      </div>

                      <div class="col-lg-3">
                        <label class="">Cabinclass</label>

                        <select class="form-control" [(ngModel)]="screen_details.cabinclass">
                          <option disabled value="0">Select Cabin Class</option>
                          <option value="A">A</option>
                          <option value="B">B</option>
                          <option value="C">C</option>
                          <option value="D">D</option>
                          <option value="E">E</option>
                        </select>
                      </div>
                    </div>

                    <div style="margin-left: 1068px;" class="btn clear-button button-margin">
                      <button style="margin-top: 20px;" class="btn btn-primary commonbutt" (click)="searchData()"
                        type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                    </div>
                  </div>
                  <br />

                  <div *ngIf="searchresult" class="reportstatus">
                    <table aria-describedby="fareProductData" class="table table-striped" [mfData]="serachtabledata"
                      [mfRowsOnPage]="5">
                      <thead>
                        <tr>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">ECO</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">PRE</mfDefaultSorter>
                          </th>

                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Redumption Multiplier</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Cancellation Multiplier</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Name</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Cabin Class</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Trip Type</mfDefaultSorter>
                          </th>

                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Flight Type</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">TPM From</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">TPM To</mfDefaultSorter>
                          </th>

                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Code</mfDefaultSorter>
                          </th>
                        </tr>

                        <tr *ngFor="
                            let item of (ViewData
                              | paginate: { itemsPerPage: 10, currentPage: p })
                          ">
                          <td>{{ item.eco }}</td>
                          <td>{{ item.pre }}</td>
                          <td>{{ item.redemption_multiplier }}</td>
                          <td>{{ item.cancellation_multiplier }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.cabin_class }}</td>
                          <td>{{ item.trip_type }}</td>
                          <td>{{ item.flight_type }}</td>
                          <td>{{ item.tpm_from }}</td>
                          <td>{{ item.tpm_to }}</td>
                          <td>{{ item.code }}</td>
                        </tr>
                      </thead>

                      <tfoot>
                        <tr>
                          <td colspan="11">
                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div *ngIf="loader">
                    <div style="margin:auto; text-align: center">
                      <img
                        src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                        width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>